const CHUNK_RECOVERY_KEY = 'saas-web:chunk-recovery'
const CHUNK_ERROR_PATTERN =
  /(?:ChunkLoadError|Loading (?:CSS )?chunk\s+\S+\s+failed)/i

export function isChunkLoadError(error) {
  const message = `${error?.name || ''} ${error?.message || error || ''}`
  return CHUNK_ERROR_PATTERN.test(message)
}

function getChunkFingerprint(error) {
  return `${error?.request || error?.message || error}`
}

export function createChunkLoadRecovery({
  storage = window.sessionStorage,
  reload = () => window.location.reload(),
} = {}) {
  return (error) => {
    if (!isChunkLoadError(error)) return false

    const fingerprint = getChunkFingerprint(error)
    try {
      if (storage.getItem(CHUNK_RECOVERY_KEY) === fingerprint) return false
      storage.setItem(CHUNK_RECOVERY_KEY, fingerprint)
    } catch (storageError) {
      return false
    }

    reload()
    return true
  }
}

export function clearChunkLoadRecovery(storage = window.sessionStorage) {
  try {
    storage.removeItem(CHUNK_RECOVERY_KEY)
  } catch (storageError) {
    return
  }
}
